import { render, staticRenderFns } from "./CancelManage.vue?vue&type=template&id=31a5bac0&scoped=true&"
import script from "./CancelManage.vue?vue&type=script&lang=js&"
export * from "./CancelManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5bac0",
  null
  
)

export default component.exports